import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { ISessionEmail } from "../../utils/types/models";

export default createEntityReducer<ISessionEmail>(Endpoint.SessionEmails, Endpoint.SessionEmailsList);
